module.exports = __webpack_public_path__ + "img/image_18.5399aeca.png";